/* eslint-disable */
import { Toast } from 'mint-ui'
import { appUser } from '@/utils'
import { $payOrderNative } from '@/utils/common/native-api'
import { isAlipay } from '@/utils/init/wx'

function getStatusValue(status) {
  status = parseInt(status)
  // 订单支付成功的事件
  if (status === 0) status = 'success'
  if (status === -1) status = 'fail'
  if (status === -2) status = 'cancel'
  return status
}
// 统一支付方法
export function Pay(order, { test } = {}) {
  console.log('支付', isAlipay(), appUser, order)

  if (test) {
    appUser.isNative = true
  }
  if (appUser.isWeixin) {
    // 微信环境下的微信支付
    return getBrandWCPayRequest(order)
  } else if (appUser.isNative) {
    // 调用原生购买方法
    return new Promise(resolve => {
      // 测试流程
      if (test) {
        return resolve({ status: 'success' })
      }
      // status: 0:win -1:error -2:cancel
      $payOrderNative(order, (orderPayResult, status) => {
        // 订单状态
        // Toast({ message: 'payOrderNative: ' + `${JSON.stringify(orderPayResult)}, ${status}` + (typeof status) })
        status = getStatusValue(status)
        resolve({ status })
      })
    })
  } else if (isAlipay()) {
    // 支付宝
    return getBrandAliPayRequest(order)
  } else if (appUser.isBrowser) {
    // if (!order.amount) return null
    return new Promise((resolve, reject) => {
      console.log(order, 'order46')
      location.href = order.mweb_url
    })
  }
  Toast('H5支付暂不支持~')
  return Promise.reject('支付未完成')
}

// 统一支付接口
export function UPIOrder(order, { dispatch, success, test }) {
  if (!(order && (order.package || order.code == 0))) {
    return Toast({ message: '支付请求失败', position: 'bottom' })
  }
  // 支付结果
  const payResult = ({ status }) => {
    switch (status) {
      case 'success':
        dispatch(status).then(({ status }) => {
          // 测试点
          if (test) {
            success && success()
            return
          }
          if (status >= 1) {
            success && success()
          } else {
            Toast({ message: '支付未完成，请稍后查询', position: 'bottom' })
          }
        })
        break
      case 'cancel':
        Toast({ message: '用户取消支付~', position: 'bottom' })
        break
    }
  }
  // 开始支付
  Pay(order, { test }).then(payResult)
}

// Pay 微信JSAPId的支付方法
export function chooseWXPay(wxorder) {
  return new Promise(resolve => {
    const request = getOrderRequest(wxorder)
    window.wx.chooseWXPay({
      ...request,
      success(res) {
        if (res.errMsg === 'chooseWXPay:ok') {
          resolve({ status: 'success' })
        } else {
          // Toast('支付失败~')
          resolve({ status: 'fail' })
        }
      },
      // 支付取消回调函数
      cancel(res) {
        // Toast('用户取消支付~')
        resolve({ status: 'cancel', res })
      },
      // 支付失败回调函数
      fail(res) {
        // Toast('支付失败~')
        resolve({ status: 'fail', res })
      }
    })
  })
}
// Pay 微信内置浏览器的支付方法
export function getBrandWCPayRequest(wxorder) {
  const request = getOrderRequest(wxorder)
  console.log('getBrandWCPayRequest', wxorder, request)
  function onBridgeReady() {
    return new Promise((resolve, reject) => {
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', request, function (res) {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          resolve({ status: 'success', res })
        } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          resolve({ status: 'cancel', res })
        } else {
          resolve({ status: 'fail', res })
        }
        console.log('getBrandWCPayRequest结果：', res)
      })
    })
  }
  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    return onBridgeReady()
  }
}
//支付宝内置浏览器
export function getBrandAliPayRequest(order) {
  return new Promise(function (resolve, reject) {
    ap.tradePay(
      {
        orderStr: order.orderInfo
      },
      function (res) {
        //ap.alert(res.resultCode);
        if (res.resultCode == '9000') {
          resolve({ status: 'success' })
        } else {
          resolve({ status: 'fail', res })
        }
      }
    )
  })
}

// Pay getOrderRequest
function getOrderRequest(order) {
  return {
    // 应用ID
    appId: order.appId || order.appid,
    // 支付签名时间戳
    timeStamp: order.timeStamp || order.timestamp,
    // 支付签名随机串，不长于 32 位
    nonceStr: order.nonceStr || order.noncestr,
    // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***
    package: order.package,
    // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
    signType: order.signType,
    // 支付签名
    paySign: order.sign
  }
}
